import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { ContractListItemComponent } from '../contract-list-item/contract-list-item.component';
import { Contract } from '@models/contract';

import { Router } from '@angular/router';

@Component({
    selector: 'app-contract-list',
    imports: [ContractListItemComponent],
    templateUrl: './contract-list.component.html',
    styleUrl: './contract-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContractListComponent {
    @Input() public contracts: Contract[] = [];
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    @Input({ required: true }) public route: string | any[] = '';

    private router = inject(Router);

    protected handleClick(id: number): void {
        const routeArray = typeof this.route === 'string' ? [this.route] : this.route;
        this.router.navigate(routeArray.map((item: string) => item.replace(':contractId', id.toString())));
    }
}
